import { useEffect, useLayoutEffect } from "react";

/**
 * `useLayoutEffect` in the browser, `useEffect` on the server.
 *
 * Used to read localStorage after mount instead of during render. The reason it
 * is a *layout* effect and not a plain one: it runs in the same commit as
 * hydration, before the browser paints, so state that only the client can know
 * — saved trips, liked ids — is in place by the first frame. A plain effect
 * would let an empty "nothing saved yet" screen flash first.
 *
 * React warns about `useLayoutEffect` during SSR, where it never runs anyway,
 * hence the swap.
 */
export const useIsomorphicLayoutEffect =
  typeof window === "undefined" ? useEffect : useLayoutEffect;
